import { Component } from '@angular/core';

@Component({
    selector: 'offlineRegimen',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class RegimenComponent {}
